
import { useState, useEffect } from "react";
import { useAuth } from "@/components/AuthProvider";
import { supabase } from "@/integrations/supabase/client";

export const useCalendarSettings = () => {
  const { user } = useAuth();
  const [settings, setSettings] = useState<any>(null);

  useEffect(() => {
    fetchSettings();
  }, [user]);

  const fetchSettings = async () => {
    if (!user) return;

    try {
      const { data, error } = await supabase
        .from("schedule_settings")
        .select()
        .eq("trainer_id", user.id)
        .maybeSingle();

      if (error && error.code !== "PGRST116") {
        console.error("Error fetching settings:", error);
        return;
      }

      // If no settings exist, create default settings
      if (!data && !error) {
        const defaultSettings = {
          trainer_id: user.id,
          work_start_time: '09:00',
          work_end_time: '20:00',
          working_days: [1, 2, 3, 4, 5],
          slot_duration: 60
        };

        const { data: newSettings, error: insertError } = await supabase
          .from("schedule_settings")
          .insert(defaultSettings)
          .select()
          .maybeSingle();

        if (insertError) {
          console.error("Error creating default settings:", insertError);
          return;
        }

        setSettings(newSettings);
        return;
      }

      setSettings(data);
    } catch (error) {
      console.error("Error:", error);
    }
  };

  return { settings, fetchSettings };
};
